if (!customElements.get("free-shipping-progress")) {
  customElements.define(
    "free-shipping-progress",
    class FreeShippingProgress extends HTMLElement {
      constructor() {
        super();
        this.renderProgress();
      }

      static get observedAttributes() {
        return ["data-total-amount"];
      }

      // Respond to attribute changes.
      // In this case, when the cart total amount changes.
      attributeChangedCallback(name, oldValue, newValue) {
        if (name !== "data-total-amount") return;
        if (oldValue === newValue) return;
        this.renderProgress();
      }

      get progressBar() {
        return this.querySelector(".free-shipping-progress");
      }

      get messageWrapper() {
        return this.querySelector(".free-shipping-message");
      }

      get statusIcon() {
        return this.querySelector(".free-shipping-icon");
      }

      renderProgress() {
        const cartTotalAmount = this.dataset.totalAmount;
        const freeThreshold = this.dataset.freeThreshold;

        if (
          !webvista.isNumeric(cartTotalAmount) ||
          !webvista.isNumeric(freeThreshold)
        ) {
          return;
        }

        const freeThresholdLocal =
          Math.round(
            parseFloat(freeThreshold) * (Shopify.currency?.rate || 1) * 100
          ) || 0;
        const cartTotal = parseInt(cartTotalAmount, 10);
        let progress = 0;

        if (cartTotal - freeThresholdLocal >= 0) {
          // Free shipping unlocked
          progress = 100;
          if (this.messageWrapper) {
            this.messageWrapper.innerHTML = this.dataset.unlockedMessage || "";
            this.messageWrapper.classList.add("text-success", "font-bold");
            this.messageWrapper.classList.remove("opacity-60");
          }
          if (this.statusIcon) {
            this.statusIcon.classList.remove("hidden");
          }
          this.classList.add("free-has-unlocked");
        } else {
          // Free shipping locked
          progress = (cartTotal * 100) / freeThresholdLocal;
          const amountToQualify = freeThresholdLocal - cartTotal;
          const formatted = webvista.formatPriceAmount(
            amountToQualify,
            Shopify.currency?.active
          );
          if (this.messageWrapper) {
            const lockedMessage = this.dataset.lockedMessage || "";
            const amountMarkup = `<strong class="opacity-100">${
              formatted || ""
            }</strong>`;
            this.messageWrapper.innerHTML = `<span class="opacity-60">${lockedMessage.replace(
              "[amount]",
              `</span>${amountMarkup}<span class="opacity-60">`
            )}</span>`;
            this.messageWrapper.classList.remove("text-success", "font-bold");
            this.messageWrapper.classList.remove("opacity-60");
          }
          if (this.statusIcon) {
            this.statusIcon.classList.add("hidden");
          }
        }

        if (this.progressBar) {
          this.progressBar.classList.add("transition-[width]");
          this.progressBar.style.width = `${progress}%`;
        }
      }
    }
  );
}
